// src/components/modals/web-modals/ContactFormModal.jsx

import BaseModalWeb from './BaseModalWeb';
import ContactFormComponent from './components/contactFormComponent';

const ContactFormModal = ({
  isOpen,
  onRequestClose,
  initialMessage = ""
}) => {
  return (
    <BaseModalWeb
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Contact Form Modal"
      className="ReactModal__Content modal--web modal--750px"
    >
      <ContactFormComponent initialMessage={initialMessage} />
    </BaseModalWeb>
  );
};

export default ContactFormModal;
